import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'

export default function UploadReducer(state = initialState, action) {
    switch (action.type) {
        case types.CERTIFICATE_INIT:

            return action.payload;
        case types.CERTIFICATE_DROPPED:

            return {
                ...state,
                files: action.payload,
                savedSucceed:false
            };
        case types.CERTIFICATE_UPLOAD_START:
            return {
                ...state,
                disableUploadButton:action.payload.value
            };
        case types.CERTIFICATE_UPLOAD:
            toast.info("Upload success",
                {
                    position: toast.POSITION.TOP_CENTER
                });
            const st = action.payload;
            let clientSecrets = state.clientSecrets;

            if (clientSecrets.length > state.selectedIndex) {
                clientSecrets[state.selectedIndex - 1].hasCertificate = true;
            }

            const newState = Object.assign({}, state, { clientSecrets: clientSecrets , files:state.files, savedSucceed:true, disableUploadButton:false});
            return newState;

        case types.CERTIFICATE_UPLOAD_ERROR:
            toast.error("A error has occured. Retry and if the problem persist contact the administrator.\r\n Technical : " + action.payload.error + "", {
                position: toast.POSITION.TOP_CENTER
            });
            return {
                ...state,
                savedSucceed:false,
                disableUploadButton:false
            };
        case types.CLIENTSECRET_INIT:
            return {
                ...state,
                clientSecrets: action.payload
            }
        case types.SELECTRIZIV:
            return {
                ...state,
                selectedIndex : action.payload
            }

        default:
            return state;
    }
};
